module.exports = __webpack_public_path__ + "img/Frame 933one.c88b9604.svg";